module.exports = __webpack_public_path__ + "img/PULSIVE VENTIL.74a1ec67.jpg";